import Select from 'react-select'
import Datetime from 'react-datetime'
import { KTSVG } from '_metronic/helpers'
import { SURVEY_STATUS_OPTIONS } from 'Configuration/Paco'
import moment from 'moment'

interface Props {
  saleOrder: any[]
  project: any[]
  filter: any
  onChangeFilter: (name: string, value: any) => void
  onClearFilter: () => void
  onSubmit: () => void
}

const Filter: React.FC<Props> = ({
  saleOrder,
  project,
  filter,
  onChangeFilter,
  onClearFilter,
  onSubmit,
}) => {
  const statusOptions = SURVEY_STATUS_OPTIONS.map(item => ({
    label: `${item.key.substring(0, 1).toUpperCase()}${item.key.substring(1).toLowerCase()} - ${
      item.title
    }`,
    value: item.key,
  }))

  const saleOrderOptions = saleOrder.map(s => ({
    label: s.code,
    value: s.id,
  }))
  const projectOptions = project.map(p => ({
    label: `${p.code} - ${p.division}`,
    value: p.id,
  }))

  return (
    <div
      id='kt_survey_filter'
      className='bg-body'
      data-kt-drawer='true'
      data-kt-drawer-name='chat'
      data-kt-drawer-activate='true'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'300px', 'md': '500px'}"
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#kt_survey_filter_toggle'
      data-kt-drawer-close='#kt_survey_filter_close'>
      <div className='card w-100 rounded-0'>
        <div className='card-header pe-5'>
          <div className='card-title'>
            {/* begin:: Title */}
            <div className='d-flex justify-content-center flex-column me-3'>
              <span className='fs-4 fw-bolder text-gray-900 text-hover-primary me-1 mb-2 lh-1'>
                ค้นหา
              </span>
            </div>
            {/* end:: Title */}
          </div>

          <div className='card-toolbar'>
            {/* begin:: Close Button */}
            <button
              className='btn btn-sm btn-bg-white btn-active-light-danger text-center'
              id='kt_survey_filter_close'>
              <KTSVG
                path='/media/icons/duotune/arrows/arr015.svg'
                className='svg-icon svg-icon-2x mx-auto'
              />
            </button>
            {/* end:: Close Button */}
          </div>
        </div>

        <div className='card-body'>
          <div
            data-kt-element='messages'
            data-kt-scroll='true'
            data-kt-scroll-activate='{default: false, lg: true}'
            data-kt-scroll-max-height='auto'
            data-kt-scroll-offset='5px'>
            <div className='row gy-5'>
              <div className='col-12'>
                <div className='fs-6 mb-3'>ชื่อหน่วยงาน</div>

                <input
                  type='text'
                  className='form-control form-control-sm'
                  placeholder='ค้นหาด้วยชื่อหน่วยงาน'
                  value={filter.division}
                  onChange={(e: any) => onChangeFilter('division', e.target.value)}
                  onKeyDown={(e: any) => {
                    if (e.key === 'Enter') {
                      onSubmit()
                      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore
                      document.querySelector('#kt_survey_filter_close')?.click()
                    }
                  }}
                />
              </div>

              <div className='col-12'>
                <div className='fs-6 mb-3'>วันที่เริ่มงาน</div>

                <Datetime
                  locale='en'
                  dateFormat='DD/MM/YYYY'
                  timeFormat={false}
                  renderInput={props => {
                    return (
                      <input
                        {...props}
                        autoComplete='off'
                        placeholder='ค้นหาด้วยวันที่เริ่มงาน'
                        value={moment(filter.startJobDate).isValid() ? props.value : ''}
                      />
                    )
                  }}
                  closeOnClickOutside
                  className='filter-date-input w-100 z-4'
                  value={filter.startJobDate}
                  onChange={(val: any) => onChangeFilter('startJobDate', val)}
                />
              </div>

              <div className='col-12'>
                <div className='fs-6 mb-3'>วันที่สิ้นสุดงาน</div>

                <Datetime
                  locale='en'
                  dateFormat='DD/MM/YYYY'
                  timeFormat={false}
                  renderInput={props => {
                    return (
                      <input
                        {...props}
                        autoComplete='off'
                        placeholder='ค้นหาด้วยวันที่สิ้นสุดงาน'
                        value={moment(filter.endJobDate).isValid() ? props.value : ''}
                      />
                    )
                  }}
                  closeOnClickOutside
                  className='filter-date-input w-100 z-4'
                  value={filter.endJobDate}
                  onChange={(val: any) => onChangeFilter('endJobDate', val)}
                />
              </div>

              <div className='col-12'>
                <div className='fs-6 mb-3'>ชื่อลูกค้า</div>

                <input
                  type='text'
                  className='form-control form-control-sm'
                  placeholder='ค้นหาด้วยชื่อของลูกค้า'
                  value={filter.customerTitle}
                  onChange={(e: any) => onChangeFilter('customerTitle', e.target.value)}
                  onKeyDown={(e: any) => {
                    if (e.key === 'Enter') {
                      onSubmit()
                      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore
                      document.querySelector('#kt_survey_filter_close')?.click()
                    }
                  }}
                />
              </div>

              <div className='col-12'>
                <div className='fs-6 mb-3'>ชื่อผู้ขาย</div>

                <input
                  type='text'
                  className='form-control form-control-sm'
                  placeholder='ค้นหาด้วยชื่อของผู้ขาย'
                  value={filter.saleTitle}
                  onChange={(e: any) => onChangeFilter('saleTitle', e.target.value)}
                  onKeyDown={(e: any) => {
                    if (e.key === 'Enter') {
                      onSubmit()
                      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore
                      document.querySelector('#kt_survey_filter_close')?.click()
                    }
                  }}
                />
              </div>

              <div className='col-12'>
                <div className='fs-6 mb-3'>ชื่อผู้ติดต่อ</div>

                <input
                  type='text'
                  className='form-control form-control-sm'
                  placeholder='ค้นหาด้วยชื่อของผู้ติดต่อ'
                  value={filter.contactPersonFullName}
                  onChange={(e: any) => onChangeFilter('contactPersonFullName', e.target.value)}
                  onKeyDown={(e: any) => {
                    if (e.key === 'Enter') {
                      onSubmit()
                      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore
                      document.querySelector('#kt_survey_filter_close')?.click()
                    }
                  }}
                />
              </div>

              {/* begin:: Job Status */}
              <div className='col-12'>
                <div className='fs-6 mb-3'>สถานะงาน</div>

                <Select
                  styles={{
                    control: (provided: any) => ({
                      ...provided,
                      borderColor: '#e1e3ea',
                    }),
                  }}
                  options={statusOptions}
                  placeholder='ค้นหาด้วยสถานะของงาน'
                  value={statusOptions.find(s => s.value === filter.jobStatus) ?? null}
                  onChange={(e: any) => onChangeFilter('jobStatus', e?.value)}
                />
              </div>
              {/* end:: Job Status */}

              {/* begin:: Sale Order */}
              <div className='col-12'>
                <div className='fs-6 mb-3'>Sale Order</div>

                <Select
                  styles={{
                    control: (provided: any, state: any) => ({
                      ...provided,
                      borderColor: '#e1e3ea',
                    }),
                  }}
                  options={saleOrderOptions}
                  placeholder='ค้นหาด้วย Sale Order'
                  value={saleOrderOptions.find(s => s.value === filter.saleOrderId) ?? null}
                  onChange={(e: any) => onChangeFilter('saleOrderId', e?.value)}
                />
              </div>
              {/* end:: Sale Order */}

              {/* begin:: Project */}
              <div className='col-12'>
                <div className='fs-6 mb-3'>Project</div>

                <Select
                  styles={{
                    control: (provided: any, state: any) => ({
                      ...provided,
                      borderColor: '#e1e3ea',
                    }),
                  }}
                  options={projectOptions}
                  placeholder='ค้นหาด้วย Project'
                  value={projectOptions.find(s => s.value === filter.projectId) ?? null}
                  onChange={(e: any) => onChangeFilter('projectId', e?.value)}
                />
              </div>
              {/* end:: Project */}

              <div className='col-12 d-flex flex-row'>
                <button
                  className='btn btn-sm btn-primary me-4 w-50 fw-bold'
                  onClick={onSubmit}
                  id='kt_survey_filter_close'>
                  ค้นหา
                </button>
                <button
                  className='btn btn-sm btn-danger w-50 fw-bolder'
                  onClick={onClearFilter}
                  id='kt_survey_filter_close'>
                  ล้างค่า
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Filter
